/**
 * Formats an array of strings for use in DuckDB queries
 *
 * @param {string[] | readonly string[]} values array of values
 * @returns bracketed list of quoted strings, ex. `['one', 'two', 'three']`

 */
export const formatStringList = (values: string[] | readonly string[]) => {
  return `[${values.map((val) => `'${val}'`)}]`;
};
